import React from 'react';
import { HelpCircleIcon } from 'lucide-react';
export function Objections() {
  return <section className="py-16 border-t border-black" data-id="element-145">
      <h2 className="text-2xl md:text-3xl font-bold mb-8 text-center flex items-center justify-center" data-id="element-146">
        <HelpCircleIcon className="h-8 w-8 text-orange-500 mr-2" data-id="element-147" />
        Preguntas Frecuentes
      </h2>
      <div className="grid md:grid-cols-2 gap-6" data-id="element-148">
        <div className="bg-black/30 p-6 rounded-lg" data-id="element-149">
          <h3 className="text-xl font-bold mb-3 text-orange-400" data-id="element-150">
            "No tengo presupuesto."
          </h3>
          <p data-id="element-151">
            Esto multiplica el ROI de lo que ya gastas. En lugar de invertir en
            soluciones temporales, adquieres una habilidad que te generará
            retorno por años.
          </p>
        </div>
        <div className="bg-black/30 p-6 rounded-lg" data-id="element-152">
          <h3 className="text-xl font-bold mb-3 text-orange-400" data-id="element-153">
            "¿Y si no es para mi nicho?"
          </h3>
          <p data-id="element-154">
            El Sistema Conversión Instantánea funciona en Shopify, afiliados y
            productos digitales. Los principios de persuasión son universales, y
            los adaptamos a tu industria específica.
          </p>
        </div>
        <div className="bg-black/30 p-6 rounded-lg" data-id="element-155">
          <h3 className="text-xl font-bold mb-3 text-orange-400" data-id="element-156">
            "Prefiero contratar a alguien."
          </h3>
          <p data-id="element-157">
            Por el precio de una fracción de lo que pagarías a un copywriter
            ($30K-$60K), aprendes la habilidad para siempre y puedes aplicarla
            en todos tus proyectos sin costos recurrentes.
          </p>
        </div>
        <div className="bg-black/30 p-6 rounded-lg" data-id="element-158">
          <h3 className="text-xl font-bold mb-3 text-orange-400" data-id="element-159">
            "He tomado cursos antes."
          </h3>
          <p data-id="element-160">
            Esto no es teoría: es práctica aplicada directamente a tu negocio.
            Trabajamos con tus productos, tu audiencia y tus objetivos
            específicos. No es un curso genérico, sino un sistema personalizado.
          </p>
        </div>
      </div>
      <div className="mt-12 text-center" data-id="element-161">
        <p className="text-xl font-bold mb-6" data-id="element-162">
          ¿Tienes más preguntas? Resuélvelas en tu llamada estratégica gratuita
        </p>
        <button className="bg-orange-500 hover:bg-orange-600 text-black font-bold py-4 px-8 rounded-full text-xl transition-all transform hover:scale-105" data-id="element-163">
          Agendar mi llamada estratégica
        </button>
      </div>
    </section>;
}